import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { EXPIRATION_PROMOTIONS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateProductExpirationPromotionAction = createAsyncThunk(
    'price/updateProductExpirationPromotionAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.put(`${ EXPIRATION_PROMOTIONS_PATH }/${ data.expirationPromotionId }`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateProductExpirationPromotionSlice = createSlice({
    name: 'updateProductExpirationPromotionSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateProductExpirationPromotionAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateProductExpirationPromotionAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateProductExpirationPromotionAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateProductExpirationPromotionState = (state) => state.price.updateProductExpirationPromotion;
export default updateProductExpirationPromotionSlice.reducer;
